module.exports = __webpack_public_path__ + "static/media/telegram.34cd4f5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/telegram.svg
// module id = 207
// module chunks = 0